import React, { useState } from 'react'

export const IsLoggedContext = React.createContext({})
export const TitlesContext = React.createContext([''])
export const ContentContext = React.createContext([''])
export const StreamContext = React.createContext('')
export const PlanContext = React.createContext('')
export const TutorFirstContext = React.createContext('')
export const TutorLastContext = React.createContext('')
export const NameSubmitContext = React.createContext('')
const Store = ({children}) => {
    const [isLogged, setIsLogged] = useState(localStorage.getItem('loggedIn'))
    const [titles, setTitles] = useState([''])
    const [content, setContent] = useState([''])
    const [globalStream, setGlobalStream] = useState('')
    const [plan, setPlan] = useState('')
    const [tutorFirst, setTutorFirst] = useState('')
    const [tutorLast, setTutorLast] = useState('')
    const [nameSubmit, setSubmit] = useState(false)
    return (
    <NameSubmitContext.Provider value={[nameSubmit, setSubmit]}>
    <TutorLastContext.Provider value={[tutorLast, setTutorLast]}>
    <PlanContext.Provider value={[plan, setPlan]}>
    <TutorFirstContext.Provider value={[tutorFirst, setTutorFirst]}>
    <StreamContext.Provider value={[globalStream, setGlobalStream]}>
    <ContentContext.Provider value={[content, setContent]}>
    <TitlesContext.Provider value={[titles, setTitles]}>
    <IsLoggedContext.Provider value={[isLogged, setIsLogged]}>
            {children}
    </IsLoggedContext.Provider> 
    </TitlesContext.Provider>
    </ContentContext.Provider>
    </StreamContext.Provider>
    </TutorFirstContext.Provider>
    </PlanContext.Provider>
    </TutorLastContext.Provider>
    </NameSubmitContext.Provider>
    )

}

export default Store
